export function searchModal(){
  const button = document.querySelector('.js_searchModalTrigger');
  // const nav = document.body.querySelectorAll('.el_hamburger_nav a');
  const target = document.querySelectorAll('[data-name="search"]')[0];
  const close = document.querySelectorAll('.js_modal_close');


    button.addEventListener('click',()=>{
        //const scrollbarWidth = window.innerWidth - document.body.clientWidth;
        //document.body.style.paddingRight = scrollbarWidth+'px';
        if (!document.body.classList.contains('fancybox-active')) {
          target.classList.toggle('is_active');
        }
    })

    close.forEach(elm => {
        elm.addEventListener('click',()=>{
          target.classList.remove('is_active');
        })
    })
}
